// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Card_card__oHhc5 {
  border-radius: 12px;
  box-shadow: 0px 8px 16px #f0f0f0;
  padding: 32px;
}

.Card_no-shadow__JQjf9 {
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  padding: 15px;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;
}

.Card_grey-card__b9fw9 {
  background-color: #f2f2f2;
  padding: 21px;
  margin-bottom: 15px;
  border-radius: 7px;
}

.Card_red-card__bn7O1 {
  background-color: #ffe6e5;
  padding: 21px;
  margin-bottom: 15px;
  border-radius: 7px;
}

.Card_blue-card__zEHmD {
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  padding: 15px;
  background-color: #ebf3ff;
}

.Card_blue-right-card__e3daA {
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  padding: 21px;
  background-color: #ebf3ff;
  float: right;
  width: 100%;
}

.Card_input-card__HSsi8 {
  border: 1px solid #e6e6e6;
  border-radius: 0px;
  padding: 15px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/common/Card/Card.module.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;EACA,gCAAA;EACA,aAAA;AADF;;AAIA;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AADF;;AAIA;EACE,yBCPoB;EDQpB,aAAA;EACA,mBAAA;EACA,kBAAA;AADF;;AAIA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AADF;;AAIA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBCzBW;ADwBb;;AAIA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBChCW;EDiCX,YAAA;EACA,WAAA;AADF;;AAIA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;AADF","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n.card {\n  border-radius: 12px;\n  box-shadow: 0px 8px 16px #f0f0f0;\n  padding: 32px;\n}\n\n.no-shadow {\n  border: 1px solid colors.$color-semantic-primary;\n  border-radius: 10px;\n  padding: 15px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n.grey-card {\n  background-color: colors.$color-background-02;\n  padding: 21px;\n  margin-bottom: 15px;\n  border-radius: 7px;\n}\n\n.red-card {\n  background-color: #ffe6e5;\n  padding: 21px;\n  margin-bottom: 15px;\n  border-radius: 7px;\n}\n\n.blue-card {\n  border: 1px solid colors.$color-semantic-primary;\n  border-radius: 4px;\n  padding: 15px;\n  background-color: colors.$light-blue;\n}\n\n.blue-right-card {\n  border: 1px solid colors.$color-semantic-primary;\n  border-radius: 4px;\n  padding: 21px;\n  background-color: colors.$light-blue;\n  float: right;\n  width: 100%;\n}\n\n.input-card {\n  border: 1px solid colors.$color-semantic-primary;\n  border-radius: 0px;\n  padding: 15px;\n  width: 100%;\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `Card_card__oHhc5`,
	"no-shadow": `Card_no-shadow__JQjf9`,
	"grey-card": `Card_grey-card__b9fw9`,
	"red-card": `Card_red-card__bn7O1`,
	"blue-card": `Card_blue-card__zEHmD`,
	"blue-right-card": `Card_blue-right-card__e3daA`,
	"input-card": `Card_input-card__HSsi8`
};
export default ___CSS_LOADER_EXPORT___;
